import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseBillingBillSupplyAuthorizationsProps<T> = {
  filters?: {
    id?: string
    search?: string
    page?: number
    governmentAllocationId?: string
    status?: string
  }
  mapper?: (data: any) => T
}

export const useBillingBillSupplyAuthorizations = <T,>({
  filters: { id, search = '', page = 1, governmentAllocationId, status } = {},
  mapper = Mapper.default<T>(),
}: UseBillingBillSupplyAuthorizationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['billingBillSupplyAuthorizations', id, search, page, governmentAllocationId, status],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/${id}/supply_authorizations`, {
        params: {
          search,
          page,
          'q[government_allocation_id]': governmentAllocationId,
          'q[status_eq]': status,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
